export function setNewDebitNotesAction(newDebitNote) {
    return {
        type: "NEW_DEBIT_NOTES",
        newDebitNotes: newDebitNote
    }
}
